import { render, staticRenderFns } from "./tabContractNoPriceFcl.vue?vue&type=template&id=6869a22f&scoped=true&"
import script from "./tabContractNoPriceFcl.vue?vue&type=script&lang=js&"
export * from "./tabContractNoPriceFcl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6869a22f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6869a22f')) {
      api.createRecord('6869a22f', component.options)
    } else {
      api.reload('6869a22f', component.options)
    }
    module.hot.accept("./tabContractNoPriceFcl.vue?vue&type=template&id=6869a22f&scoped=true&", function () {
      api.rerender('6869a22f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/partner/tab/tabContractNoPriceFcl.vue"
export default component.exports